import React, { useState } from 'react';
//import LocationList from '@/components/Location/MaintainLocation';
import CountryList from '@/components/Country/MaintainCountry';
// import BookingForm from '@/components/booking/BookingForm';
// import BookingPrint from '@/components/booking/BookingPrint';

const CountryClause = () => {
    const [view, setView] = useState('list'); // list | form | print

    const handleCreateNew = () => {

        setView('form');
    };

    const handleViewShipment = () => {

        setView('form');
    };

    const handlePrintShipment = () => {
        setView('print');
    };



    return (
        <div className="h-full p-4">
            {view === 'list' && (
                <CountryList
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}
                    onPrintShipment={handlePrintShipment}
                />
            )}

            
        </div>
    );
};

export default CountryClause;
